import React from "react";
import { typeAssets } from "../../assets/type_assets";
import { listData } from "../../types/copyText";

export const ContainerInfo = () => {
	return (
		<>
			<div className="relative">
				<img className="w-full" src={typeAssets.cardIfografia} alt="card" />
				<div className="rounded-md absolute z-10 bg-accent text-white text-[14px] active:text-white active:bg-[#AA5600] top-[38%] left-[35%] w-[145px] h-[32px] py-2 px-6 flex justify-center items-center">
					<a
						href="https://www.grupociosa.mx/listado/accesorios-vehiculos/refacciones-autos-camionetas/frenos/"
						target="_blank"
						rel="noreferrer"
					>
						Comprar
					</a>
				</div>
				<div className="rounded-md absolute z-10 bg-[#585858] text-white text-[14px] active:text-white active:bg-[#424242] top-[52%] left-[35%] w-[145px] h-[32px] py-2 px-6 flex justify-center items-center">
					<a href="https://www.ciosa.com/autopartes" target="_blank" rel="noreferrer">
						Conocer más
					</a>
				</div>
			</div>
			<div className="flex flex-col gap-4 pl-12 pr-6 pb-7">
				{listData.map((list, index) => (
					<ListData key={`${index}-list`} title={list.title} subtitle={list.subtitle} />
				))}
			</div>
		</>
	);
};

const ListData = ({ title = "", subtitle = "" }) => {
	return (
		<div className="grid grid-cols-listColumns">
			<div className="">
				<img className="h-[20px] w-[20px]" src={typeAssets.icon.iconlist} alt="list" />
			</div>
			<div className="pl-3 flex flex-col text-[12px]">
				<span className="text-accent uppercase">{title}</span>
				<span className="text-white">{subtitle}</span>
			</div>
		</div>
	);
};
